<!-- 
	@component
	Simple FAQ component that hides and shows the answer to questions.

	Usage:
	```svelte
	<Faq questions={[
		        { 'question': 'question 1', 'answer': 'answer1', show: false },
        		{ 'question': 'question 2', 'answer': 'answer2', show: false },
	]} />
	```
 -->
<script lang="ts">
	import { Plus, XMark } from '@steeze-ui/heroicons';
	import { Icon } from '@steeze-ui/svelte-icon';
	import classNames from 'classnames';

	export let questions: { question: string; answer: string; show: boolean }[];
</script>

<div class={classNames($$props.class)}>
	{#each questions as { question, answer, show }}
		<div class="faq-section border-b border-neutral-content px-2 py-8">
			<div class="flex justify-between">
				<div>
					<button aria-label="faq button" class="text-xl font-bold text-left" on:click={() => (show = !show)}>
						{@html question}
					</button>
					<p class={!show ? 'hidden' : 'mt-4 w-full text-base text-neutral-content'}>
						{@html answer}
					</p>
				</div>
				<div>
					{#if show}
						<button aria-label="faq button" on:click={() => (show = !show)}>
							<Icon src={XMark} width="20px" height="20px" />
						</button>
					{:else}
						<button aria-label="faq button" class="text-accent" on:click={() => (show = !show)}>
							<Icon src={Plus} width="20px" height="20px" />
						</button>
					{/if}
				</div>
			</div>
		</div>
	{/each}
</div>

<style lang="postcss">
	.faq-section :global(a) {
		text-decoration: underline;
		color: white;
		font-weight: 700;
	}
</style>
